import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Schedule } from './components/Schedule';
import { WhyTrucking } from './components/WhyTrucking';
import { Programs } from './components/Programs';
import { ValueStatement } from './components/ValueStatement';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsOfService } from './components/TermsOfService';
import { Giveaway } from './components/Giveaway';
import { GiveawayRules } from './components/GiveawayRules';
import Fleet from './components/Fleet';
import AdminDashboard from './components/AdminDashboard';
import { Toaster } from './components/ui/sonner';

const HomePage = () => (
  <>
    <Header />
    <Hero />
    <Schedule />
    <WhyTrucking />
    <Programs />
    <ValueStatement />
    <Testimonials />
    <FAQ />
    <Contact />
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/giveaway" element={<Giveaway />} />
          <Route path="/giveaway-rules" element={<GiveawayRules />} />
          <Route path="/fleet" element={<Fleet />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
